import { deriveLogicalProjectKey } from "../../logicalProject";
import type { Project } from "../../types";
import type { BreadcrumbCrumb } from "../breadcrumb/globalBreadcrumb.logic";
import { savedBreadcrumbProjectRouteKey } from "../breadcrumb/savedThreadBreadcrumb";
import type { ActiveProjectPresentation } from "./activeProjectPresentation";
import type { ProjectCanonicalIdentity } from "../ProjectIcon";

export function resolveNewThreadBreadcrumb(
  project: Project | null,
  presentation: ActiveProjectPresentation,
  catalogRow: {
    readonly cmmdProjectId: number;
    readonly githubRepoFullName?: string | null;
  } | null,
  linkedIdentity?: ProjectCanonicalIdentity,
): BreadcrumbCrumb | null {
  if (!presentation.name) return null;
  const routeKey =
    savedBreadcrumbProjectRouteKey(
      { repository: catalogRow?.githubRepoFullName ?? null },
      project ? deriveLogicalProjectKey(project) : null,
    ) ?? catalogRow?.cmmdProjectId.toString();
  return {
    key: "thread-project",
    label: presentation.name,
    ...(routeKey ? { to: `/project/${encodeURIComponent(routeKey)}` } : {}),
    icon: {
      name: presentation.name,
      environmentId: presentation.environmentId ?? undefined,
      cwd: presentation.gitCwd ?? undefined,
      canonicalIdentity:
        presentation.summary?.icon || presentation.summary?.iconUrl
          ? {
              icon: presentation.summary.icon ?? null,
              iconUrl: presentation.summary.iconUrl ?? null,
            }
          : linkedIdentity,
    },
  };
}
